import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    class: "exercise-data-style-input",
    inputId: _ctx.fieldName,
    modelValue: _ctx.selectedValue,
    options: _ctx.options,
    optionLabel: "label",
    optionValue: "value",
    "onUpdate:modelValue": _ctx.updateValue
  }, null, 8, ["inputId", "modelValue", "options", "onUpdate:modelValue"]))
}